import classNames from 'classnames';
import React from 'react';

const RadioButton = function(props) {
  return (
    <div className='form__radio_button' style={ props.customstyle }>
      <input className={ classNames('form__radio_button__input', props.className) }
        type='radio'
        { ...props } />
      <label htmlFor={ props.id } />
    </div>
  );
};

export default RadioButton;



// WEBPACK FOOTER //
// ./app/components/shared/form/_RadioButton.jsx